module.exports = __webpack_public_path__ + "img/water-percent.b54f55fd.png";